import useId from '../utils/useId';
import * as React from 'react';
export const vantaSvg = React.forwardRef(function vantaSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#AC55FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'mask',
      {
        id: `bi_vanta__a_${id_0}`,
        style: {
          maskType: 'luminance',
        },
        maskUnits: 'userSpaceOnUse',
        x: 2,
        y: 2,
        width: 28,
        height: 28,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M30 2H2v28h28V2Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        mask: `url(#bi_vanta__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16 29.727c7.581 0 13.727-6.146 13.727-13.727S23.58 2.273 16 2.273 2.273 8.42 2.273 16 8.42 29.727 16 29.727Z',
        fill: '#F8F4F3',
        stroke: '#240642',
        strokeWidth: 0.547,
      }),
      /*#__PURE__*/ React.createElement(
        'mask',
        {
          id: `bi_vanta__b_${id_1}`,
          style: {
            maskType: 'alpha',
          },
          maskUnits: 'userSpaceOnUse',
          x: 2,
          y: 2,
          width: 28,
          height: 28,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16 29.973c7.717 0 13.973-6.256 13.973-13.973 0-7.717-6.256-13.973-13.973-13.973C8.283 2.027 2.027 8.283 2.027 16c0 7.717 6.256 13.973 13.973 13.973Z',
          fill: '#AC55FF',
          stroke: '#000',
          strokeWidth: 0.055,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          mask: `url(#bi_vanta__b_${id_1})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16.75 31.009c4.954 0 7.515-1.535 8.289-3.075.044-.089-.041-.19-.135-.158-.872.288-1.523-.247-1.596-.866 0 0-.244-2.623-1.116-2.879.051-.106.262-.944-.388-1.719.178-.548.03-.908-.102-1.181a1.73 1.73 0 0 0 .34-.704c.013-.06.013-.112.061-.168.306-.254.645-.464.85-.837.37-.673.123-1.442-.327-2.01-.045-.063-.08-.093-.084-.254 0-.275-.049-.558-.197-.79a1.61 1.61 0 0 0-.278-.316c-.431-.402-.948-.7-1.444-1.02-.068-.044-.147-.102-.177-.182-.156-.58-.56-1.03-1.062-1.153-.01-.389-.42-.98-1.041-.98-.19 0-.347.104-.444-.074-.227-.43-.68-.51-.916-.521-.04-.002-.05-.055-.015-.072.076-.037.19-.087.36-.152.853-.408.5-2.733.151-3.96-.163-.458-.577-1.76-1.591-1.847a.578.578 0 0 0-.21.015c-.195.056-.34.213-.441.43-.335.674-.42 2.495-.543 3.273-.175 1.11-.333 2.301-.886 2.79-.236-.622-.577-.91-.763-.9-.162.039.057.354-.036.82-.065.267-.213.517-.466.517-.739 0-1.405-3.698-1.604-5.92a1.88 1.88 0 0 0-.021-.174c-.098-.537-.38-.854-.679-.854-.15 0-.694-.055-1.316.924-.428.763-.7 1.56-.726 3.046 0 1.497.668 2.498.938 2.99 1.106 1.818 1.253 2.446 1.044 3.554-.212 1.074.436 1.678.436 1.678-.091.143-.213.523-.24.941-.018.266.036.743.163 1.039-.279.6-.272 1.079-.272 1.38 0 .698-.305.982-.7 1.106.106.381.816.585 1.227.178-.121 1.196-.345 2.273-.658 3.606-.195.912-.162 1.424-.014 1.857.066.195.17.375.297.537 1.515 1.933 4.359 2.085 6.331 2.085Zm-.003-2.61a2.469 2.469 0 0 1-1.43-.772c-.993.329-2.026-.507-1.712-1.611.05-.145.265-.092.244.059a.956.956 0 0 0 .088.565.826.826 0 0 0 1.29.29c.15-.132.366-.082.468.082.888 1.205 2.73.98 3.349-.374.09-.189.15-.39.184-.597.024-.147.245-.133.25.016.05 1.456-1.312 2.57-2.732 2.343Z',
          fill: '#240642',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M22.318 18.002c-.095 0-.197.133-.223.339-.057.29-.037.829-.297.829-.179 0-.195-.36-.496-.693-.313-.322-.761-.355-1.049-.587a.507.507 0 0 1-.244-.482s.034-.373.537-.305c.24.025.628.084.868.111.43.049.534-.27.547-.38.028-.254-.242-.464-.413-.613a5.38 5.38 0 0 0-.695-.508 11.1 11.1 0 0 1-.134-.084c-.612-.39-1.699-1.043-2.309-.298-.218.293-.313.63-.381.91-.127.51-.393.708-.581 1.02-.3.495-.506 1.057-.522 1.636-.002.835.514 1.653 1.338 2.165.684.358 1.035.358 1.308.285.05-.017.16-.093.085-.22-.014-.027-.052-.086-.075-.125-.078-.143.029-.275.187-.152.104.082.21.163.333.213a.52.52 0 0 0 .327.03c.125-.04.189-.122.196-.227a.279.279 0 0 0-.143-.273 5.244 5.244 0 0 1-.59-.34 2.778 2.778 0 0 1-.366-.322c-.182-.193-.234-.381-.347-.381a.076.076 0 0 0-.05.026c-.07.076-.071.2-.075.272-.002.052.006.132-.067.132-.183 0-.182-.38-.182-.483 0-.141.052-.508.27-.508.067 0 .159.09.195.126.481.534 1.04.95 1.748.95.542 0 .995-.307 1.28-.594.223-.224.37-.505.38-.794.006-.184-.082-.675-.36-.675Zm-3.107.497c-.066.037-.144-.009-.216-.032a.47.47 0 0 0-.427.095.794.794 0 0 0-.194.241c-.055.1-.066.233-.184.233-.098 0-.147-.135-.158-.19-.057-.303.09-.64.36-.785.272-.145.649-.069.824.184.027.04.05.084.054.131.003.048-.017.1-.059.123Zm-3.573-3.463a.996.996 0 0 0-.694.303c-.103.106-.333.448-.31.976-.004.078-.106.105-.147.04a1.112 1.112 0 0 1-.11-.835c.142-.46.544-.844 1.088-.844.714 0 .893.467.929.612.017.06-.057.104-.103.061-.118-.11-.3-.313-.653-.313Z',
          fill: '#fff',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M15.697 16.08a.283.283 0 0 1-.32-.265.288.288 0 0 1 .268-.32.29.29 0 0 1 .323.268.286.286 0 0 1-.271.317Zm-5.589-3.188c-.251 0-1.076-1.338-1.076-3.228 0-.848.218-1.753.613-1.753.244 0 .299.519.31.673.128 1.623-.08 2.725.225 4.195.02.087-.032.113-.072.113Z',
          fill: '#fff',
        }),
      ),
    ),
  );
});
vantaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vanta = {
  category: 'brand',
  colorable: false,
  name: 'vanta',
  svg: vantaSvg,
};
